import React from 'react'
import "../Components/DeletePopup.scss"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const Addpopup = ({ visible, onHide, onConfirm }) => {
    const footerContent = (
        <div className='popup-buttons'>
            <Button label="Cancel"  onClick={onHide}  className='addcancel-btn'/>
            <Button label="Add"  onClick={onConfirm} autoFocus className="addpopup-btn"/>
        </div>
    );

    const headerContent = (
    <i className="pi pi-folder-plus" style={{ color: '#24D920',padding:"15px",fontSize:"24px", backgroundColor:'#E2FEE9', borderRadius:'30px', marginLeft:'20px' }}></i>
    )

    return (
        
        <div className="card flex justify-content-center ">
            <Dialog header={headerContent} visible={visible} style={{ width:"400px",height:"300px" }} onHide={onHide} footer={footerContent} className="popup-dialogbox">
                <h2 className='popup-title'>Add Section</h2>
                
                <p className="popup-content">
                Are you sure you want to add this Section? This action cannot be undone.
                </p>
            </Dialog>
        </div>
    )
    
}

export default Addpopup